module.exports = __webpack_public_path__ + "static/media/IMG_6965 edit.1a4a5b40.jpg";